import { h } from 'vue';
import { Flex } from '@phi/components/layout';
import { Text } from '@components/text';
import { PhiLogo } from '@components/icons';
import { rem } from '@phi/util/css';

export const PhiLogoWithlabel = (light: boolean) => h(Flex, {
    direction: 'row',
    gap: 'tight',
}, () => [
    PhiLogo(light, rem(3)),
    h(Text, { size: 'huge' }, () => 'Phi'),
]);
